import { cn } from "@/lib/utils";

export interface SkeletonProps {
  height?: string | number;
  width?: string | number;
  useAnimation?: boolean;
  isDarkMode?: boolean;
  borderRadius?: string;
  classNames?: string;
  testId?: string;
}

export const Skeleton = ({
  height,
  width,
  useAnimation = true,
  isDarkMode = false,
  borderRadius = "4px",
  classNames,
  testId,
}: SkeletonProps) => {
  return (
    <div
      className={cn(
        isDarkMode ? "tw-bg-gray-800" : "tw-bg-gray-200",
        {
          "tw-animate-pulse": useAnimation,
          "tw-w-[400px]": !width,
          "tw-h-[400px]": !height,
          "tw-rounded-4": !height,
        },
        classNames,
      )}
      style={{ width, height, borderRadius }}
      aria-busy="true"
      aria-hidden="true"
      data-testid={testId}
    >
      <span className="tw-sr-only">Loading...</span>
    </div>
  );
};
